import React from "react";

import OutlinedButton from "./../../components/buttons/Outlined";
import ContainedButton from "./../../components/buttons/Contained";

import styles from './IconListSection.module.scss';
import IconTextCard from "../../components/icon-text-card/IconTextCard";
import type {IconTextCardData, PartnerVariant} from "../../types";
import {COLORS, EMOJIS} from "../../../../../config/constants";
import {useWindowWidth} from "../../../../../services/useWindowWidth";
import H1 from "../../components/typography/H1";
import H4 from "../../components/typography/H4";
import certCentersRu from '../../locales/certCentersRu';


const transportCards: IconTextCardData[] = [
    {
        title: 'A complete approach',
        desktopEmoji: EMOJIS.GLOBE,
        emoji: EMOJIS.HANDSHAKE_LIGHT,
        text: 'Vedmarket is a platform for complete import cost planning, with your services at its core'
    },
    {
        title: 'Transparent deals',
        desktopEmoji: EMOJIS.RECEIPT,
        emoji: '💪🏻',
        text: 'See the full picture for every request: route, cargo and the client’s planned costs'
    },
    {
        title: 'Ready-to-buy clients',
        desktopEmoji: EMOJIS.HANDSHAKE_LIGHT,
        emoji: '✍🏻',
        text: 'Receive requests from clients who have set their budget and are ready to proceed'
    },
    {
        title: 'Lower costs',
        desktopEmoji: EMOJIS.MONEY_BAG,
        emoji: '👍🏻',
        text: 'Spend less on marketing and negotiations. Get straight to work'
    },
];

type IconListSectionProps = {
    variant?: PartnerVariant;
};

function IconListSection({variant = 'transport'}: IconListSectionProps) {
    const width = useWindowWidth();

    const isCertificationCenter = variant === 'cert-centers';
    const cards = isCertificationCenter ? certCentersRu.benefits.cards : transportCards;
    const title = isCertificationCenter
        ? certCentersRu.benefits.title
        : 'Why transport companies choose us';

    const useWhiteButtons = true;
    const isSmallScreen = width >= 576 && width <= 1399;
    const CalloutHeading = H4;

    return (
        <div className={styles.section}>
            <div className={styles.sectionContainer}>
                <div className={styles.grid}>
                    <div className={styles.title}>
                        <H1 allowShortLastWordWrap={isSmallScreen} sx={{
                            color: COLORS.WHITE,
                            '@media (min-width: 576px)': {
                                overflowWrap: 'normal',
                                minWidth: 0,
                            },
                        }}>{title}</H1>
                    </div>
                    {cards.map((item, index) => (
                        <IconTextCard key={index} item={item} />
                    ))}

                    <div className={styles.lastBlock}>
                        <CalloutHeading className={styles.lastTitle} sx={{
                            color: COLORS.WHITE,
                            '@media (min-width: 992px) and (max-width: 1199px)': {
                                alignItems: 'center',
                                display: 'flex',
                            },
                            '@media screen and (min-width: 768px) and (max-width: 1199px)': {
                                overflowWrap: 'normal',
                                lineHeight: 1.3,
                            },
                            '@media screen and (max-width: 575px)': {
                                display: 'block',
                            },
                            '@media (min-width: 576px) and (max-width: 767px)': {
                                display: 'block',
                            },
                        }}>Join us</CalloutHeading>
                        <div className={styles.lastContent}>
                          <div className={styles.buttonsBlock}>
                            <ContainedButton className={styles.calloutButton} icon={width >= 768 ? 'handshake' : null} isWhite={useWhiteButtons} mobileSpacing="compact" fixedMobileHeight>Become a partner</ContainedButton>
                            <OutlinedButton className={styles.calloutButton} icon={width >= 768 ? 'play' : null} isBlack={useWhiteButtons} mobileSpacing="compact" fixedMobileHeight subduedMobileBorder>Watch demo</OutlinedButton>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default IconListSection
